import * as React from 'react';
import {
	Button,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
	useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

type Props = {
	onConfirm: () => void;
	onCancel: () => void;
	loading: boolean;
};

const DeleteWindow: React.FC<Props> = ({ onConfirm, onCancel, loading }: Props) => {
	const theme = useTheme();
	const { t } = useTranslation();

	return (
		<>
			<DialogTitle sx={{ fontWeight: 'bold' }}>
				{t('storages:t.deleteConfirm')}
			</DialogTitle>
			<DialogContent>
				<Typography variant="body1" sx={{ mb: 2 }}>
					{t('storages:t.deleteConfirmText')}
				</Typography>
			</DialogContent>
			<DialogActions>
				<Button
					color="secondary"
					onClick={onCancel}
					sx={{
						...theme.typography.buttons,
						background: 'var(--V_Green_1F9122, #1F9122)',
						color: '#FFF',
					}}
				>
					{t('common:t.cancel')}
				</Button>
				<Button
					color="primary"
					onClick={onConfirm}
					disabled={loading}
					sx={{
						...theme.typography.buttons,
						color: 'var(--V_Green_1F9122, #1F9122)',
						border: '1px solid #1F9122',
					}}
				>
					{t('storages:t.deleteStorage')}
				</Button>
			</DialogActions>
		</>
	);
};

export default DeleteWindow;

